import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=5c31d665&scoped=true&"
import script from "./LinkIcon.vue?vue&type=script&lang=ts&"
export * from "./LinkIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31d665",
  null
  
)

export default component.exports